import { Box, IconButton, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useIsMobile } from "src/hooks/useIsMobile";
import HolaVidaLogo from "src/assets/HolaVidaLogo";
import ProgressBar from "src/components/ProgressBar";
import SelectLanguage from "src/components/SelectLanguage";
import { Paths } from "src/constants/paths";
import { useCallback } from "react";
import { VisitType } from "src/api/types";
import { useUpdateVisit } from "src/hooks/useUpdateVisit";

interface Props {
  hasNoProgressBar?: boolean;
  hasNoLanguageSelect?: boolean;
  visitType?: VisitType;
}
const OnboardingNavBar = ({
  hasNoProgressBar,
  hasNoLanguageSelect = false,
  visitType,
}: Props) => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const updateVisit = useUpdateVisit();

  const navigateToDashboard = useCallback(() => {
    if (visitType === "Cancellation") {
      updateVisit({
        canceled_at: new Date().toISOString(),
        status: "canceled",
      });
      navigate(Paths.PATIENT_DASHBOARD, { replace: true });
      return;
    }

    if (visitType === "Upsell") {
      return navigate(Paths.PATIENT_DASHBOARD, { replace: true });
    }
    return undefined;
  }, [navigate, updateVisit, visitType]);

  return isMobile ? (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      position="relative"
      top={3}
      p={0.5}
      borderBottom={"1px solid #00000"}
    >
      <IconButton
        aria-label="Go back"
        sx={{
          padding: "9px",
          color: "#000000",
        }}
        onClick={() => navigate(-1)}
      >
        <KeyboardBackspaceIcon fontSize="medium" />
      </IconButton>

      {hasNoProgressBar ? null : (
        <Box sx={{ flex: 1, mx: 2 }}>
          <ProgressBar />
        </Box>
      )}
      {hasNoLanguageSelect ? null : <SelectLanguage size="small" />}
      <HolaVidaLogo
        style={{ width: "90px", height: "auto" }}
        onClick={navigateToDashboard}
      />
    </Box>
  ) : (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      pl={11}
      pr={10}
    >
      <IconButton
        aria-label="Go back"
        sx={{ padding: "9px", color: "#000000" }}
        onClick={() => navigate(-1)}
      >
        <KeyboardBackspaceIcon fontSize="large" />
      </IconButton>

      {hasNoProgressBar ? null : (
        <Box pl={9} sx={{ flex: 2, mx: 2, maxWidth: "600px" }}>
          <ProgressBar />
        </Box>
      )}
      <Stack direction="row" gap={1} alignItems="center">
        {hasNoLanguageSelect ? null : <SelectLanguage size="small" />}
        <HolaVidaLogo
          data-testid="logo"
          style={{ width: "140px", height: "auto" }}
          onClick={navigateToDashboard}
        />
      </Stack>
    </Box>
  );
};

export default OnboardingNavBar;
